var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M23,4H17V1a1,1,0,0,0-1-1H8A1,1,0,0,0,7,1V4H1A1,1,0,0,0,1,6H23a1,1,0,0,0,0-2ZM9,2h6V4H9Z"}}),_c('path',{attrs:{"d":"M3,8V21a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V8ZM16.414,18.985,15,20.4l-3-3-3,3L7.586,18.985l3-3-3-3L9,11.571l3,3,3-3,1.414,1.414-3,3Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }